import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ChipToggleComponent } from '../../../../shared/payee-cases/chip-toggle/chip-toggle.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payee-case-mokk-with-media-filter',
  templateUrl: './payee-case-mokk-with-media-filter.component.html',
  imports: [ChipToggleComponent, TranslateModule],
})
export class PayeeCaseMokkWithMediaFilterComponent {
  @Input({ required: true }) control!: FormControl<boolean>;
}
